




export default {
  name: 'basic-icon',

  props: {
    icon: String
  }
}
